import {lazy, Suspense} from "react";
import styled from "@emotion/styled";
import {breakpoints} from "@/styles/sizes";
import HomepageHeroSection from "@/components/homepage/sections/HomepageHeroSection";
import TourCard from "@/components/homepage/cards/TourCard";

// Lazy load below-the-fold components
const GridWrapper = styled.div`
  margin: 50px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;

  @media only screen and (${breakpoints.mobile}) {
    grid-template-columns: 1fr;
    padding: 20px;
  }
`;

export default function RegionPage({ data }) {
    // Destructure `data` for easier access
    const { reviewOverlay, page, socialLinks, searchOptions } = data?.data || {};
    const { heroImage, tours, data: pageData } = page || {};
    const { hero } = pageData || {};

    return (
        <div>
            {/* Hero Section - Above-the-Fold Content */}
            <div className="container">
                <HomepageHeroSection
                    reviewOverlayData={reviewOverlay}
                    backgroundImageUrl={heroImage?.url}
                    title={hero?.title}
                    socialLinks={socialLinks}
                    searchOptions={searchOptions}
                />
            </div>

            {/* Tours Section - Lazy Loaded */}
            <div className="container" style={{ padding: "20px" }}>
                <GridWrapper>
                    {tours?.map((item, index) => (
                        <TourCard item={item} key={index} />
                    ))}
                </GridWrapper>
            </div>
        </div>
    );
}
